// @module C3.ShoppingExtensions.PLP
define('C3.ShoppingExtensions.VisualSystemPage.MediaMacro.View'
,	[
	'visual_systempage_media_macro_view.tpl'
	
		, 'AjaxRequestsKiller'
		,   'Utils'
    ]
, function (
	visual_systempage_media_macro_view_tpl
	
	,   AjaxRequestsKiller
	,   Utils
)
{
    'use strict';

	// @class C3.ShoppingExtensions.PLP.View @extends Backbone.View
	return Backbone.View.extend({

		template: visual_systempage_media_macro_view_tpl

	,	initialize: function (options) {
			this.application = options.application;
			this.model = options.model;
			//this._render();
		}

	,	events: {
		}

	/*,  render: function(){
			this._render();
	    }*/


	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return C3.ShoppingExtensions.PLP.View.Context
	,	getContext: function getContext()
		{
			//console.log(this.model.get('value'))
			return {
				video : this.model.get('video'),
				isPhoneDevice : Utils.isPhoneDevice()
			};
		}
	});
});
